var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_6093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.15 1.34994L14.15 5.34994C14.05 5.44994 14 5.56994 14 5.70994V13.8799C14 14.3099 14.51 14.5399 14.83 14.2499L18.83 10.6499C18.94 10.5599 19 10.4199 19 10.2799V1.70994C19 1.25994 18.46 1.03994 18.15 1.34994ZM22.47 5.19994C22 4.95994 21.51 4.75994 21 4.58994V16.6199C19.86 16.2099 18.69 15.9999 17.5 15.9999C15.6 15.9999 13.72 16.5399 12 17.5799V5.47994C10.38 4.54994 8.51 3.99994 6.5 3.99994C4.71 3.99994 3.02 4.43994 1.53 5.19994C1.2 5.35994 1 5.70994 1 6.07994V18.1599C1 18.9199 1.81 19.3899 2.48 19.0299C3.69 18.3999 5.05 17.9999 6.5 17.9999C8.57 17.9999 10.48 18.8199 12 19.9999C13.52 18.8199 15.43 17.9999 17.5 17.9999C18.95 17.9999 20.31 18.3999 21.52 19.0399C22.19 19.3999 23 18.9299 23 18.1699V6.07994C23 5.70994 22.8 5.35994 22.47 5.19994Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_6093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookLearning);
export default __webpack_public_path__ + "static/media/BookLearning.ecb6befdaa1dc2145ecc584d56961ad3.svg";
export { ForwardRef as ReactComponent };